import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="mt-32 bg-[#283828] text-[#F1F2EC]"
      data-testid="site-footer"
    >
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-4xl mb-4 tracking-tight">Dobhai<span className="text-[#C9D1B5]">Official</span></div>
          <p className="text-sm text-[#C9D1B5] max-w-md leading-relaxed">
            A premium photography house crafting timeless imagery for weddings,
            fashion and luxury brands across Pakistan and the world.
          </p>
          <div className="flex gap-5 mt-8">
            <a href="https://www.instagram.com/dobhai_official?stkn=Mzk4c3VtNWpoN3Vz" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-white transition-colors">
              <Instagram strokeWidth={1.25} size={20} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-white transition-colors">
              <Youtube strokeWidth={1.25} size={20} />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-[#C9D1B5] mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
            <li><Link to="/booking" className="hover:text-white">Booking</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#C9D1B5] mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} strokeWidth={1.25}/> +92 323 5464594</li>
            <li className="flex items-center gap-2"><Phone size={14} strokeWidth={1.25}/> +974 5053 8523</li>
            <li className="flex items-center gap-2"><Mail size={14} strokeWidth={1.25}/> usmansajid25@gmail.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3a4d3a]">
        <div className="container-x py-6 text-xs text-[#9daa9d] flex justify-between">
          <span>© {new Date().getFullYear()} DobhaiOfficial. All rights reserved.</span>
          <span>Made with care in Lahore & San Francisco</span>
        </div>
      </div>
    </footer>
  );
}